import Modal from "../Modal/Modal";
import "./taskItem.css";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { useState } from "react";
function TaskItem({
  onClose,
  open,
  id,
  name,
  surname,
  username,
  age,
  followers,
  city,
  email,
  completed,
}) {
  /* function to update firestore */
  const [checked, setChecked] = useState(completed);

  const handleChange = async () => {
    const taskDocRef = doc(db, "users", id);
    try {
      await updateDoc(taskDocRef, {
        completed: checked,
      });
    } catch (err) {
      alert(err);
    }
  };
  return (
    <Modal modalLable="Task Item" onClose={onClose} open={open}>
      <div className="taskItem">
        <h2>{name}</h2>
        <p>{surname}</p>
        <p>{username}</p>
        <p>{followers}</p>
        <p>{age}</p>
        <p>{city}</p>
        <p>{email}</p>
      </div>
    </Modal>
  );
}

export default TaskItem;
